<template>
    <div class="flex-all" @mouseenter="showActions" @mouseleave="hideActions">
        <i class="ico-alert color-6 huge"></i>
        <input class="col-sm-10" type="text" v-if="inputType" v-model="reservation.notes[index].note" @keyup.enter="editedNote">
        <span v-else>
            {{ reservation.notes[index].note }}
        </span>
        
        <transition name="fade">
            <div class="notes-actions" v-if="actions">
                <i class="ico-edit pointer largest medium" @click="editNote"></i>
                <i class="ico-delete pointer largest medium" @click="deleteNote"></i>
            </div>
        </transition>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        props: {
            reservation: Object,
            index: Number,
        },
        data: function() {
            return { 
                actions: false,
                inputType: false
            }
        },
        computed: {
            ...mapGetters([
                'getNotes',
            ]),
        },
        methods: {
            showActions: function() {
                this.actions = true;
            },
            hideActions: function() {
                this.actions = false;
            },
            deleteNote: function(note) {
                this.reservation.notes.splice(this.index, 1);
            },
            editNote: function() {
                this.inputType = true;
            },
            editedNote: function() {
                this.inputType = false;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .notes-actions {
        display: inline-block;
        position: relative;
        padding-bottom: 0;
    }
</style>


// WEBPACK FOOTER //
// Note.vue?1b917ace